import React from "react";

import Library from "./Library";

import styles from "./User.module.css";

const BooksByAuthor = ({ author }) => {
  return (
    <>
      <div className={styles.MainContainer}>
        <div
          className={styles.UserPage}
          style={{ width: "90%", marginLeft: "5%" }}
        >
          <h3>
            Books by author: <b>{author}</b>
          </h3>
          <Library title="" />
        </div>
      </div>
    </>
  );
};

export default BooksByAuthor;
